import qs from 'qs';
import { network } from 'services/network';

export const switchUser = (params) => {
    const querystring = qs.stringify({ userName: params.userName }, { addQueryPrefix: true, skipNulls: true });

    return network.post(`admin/bo/switchUser${querystring}`).then((response) => {
        return response.data;
    });
};
